import React, { Fragment } from 'react';
import Form from '../../form';
import CommonDataService from '../../../services/CommonDataService';

class DecipherDetails extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      decipherTypes: []
    }
  }

  componentDidMount() {
    CommonDataService
      .getDecipherTypes()
      .then(decipherTypes => this.setState({ decipherTypes }));
  }

  render() {

    return (
      <Fragment>
        <Form.FieldGroup label="Number of questions*" className="right to-right">
          <Form.Input
            name="decipher.numberOfQuestions"
            step="1"
            type="number"
            placeholder="0"
            className="max-320" />
          <Form.FieldError name="decipher.numberOfQuestions" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Type*">
          <Form.Dropdown
            name="decipher.decipherType"
            options={this.state.decipherTypes}
            multi={false} />
          <Form.FieldError name="decipher.decipherType" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Countries">
          <Form.CountrySelect
            name="countries" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Logos/Branding">
          <Form.Input
            name="decipher.branding"
            type="checkbox" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Special elements">
          <div className="two-col">
            <div className="col">
              <label className="row">
                <Form.Input
                  name="decipher.discreetChoiceModeling"
                  label="DCM"
                  type="checkbox" />
              </label>
              <label className="row">
                <Form.Input
                  name="decipher.maxDiff"
                  label="MD"
                  type="checkbox" />
              </label>
              <label className="row">
                <Form.Input
                  name="decipher.hotSpots"
                  label="Hot spots"
                  type="checkbox" />
              </label>
              <label className="row">
                <Form.Input
                  name="decipher.highlighters"
                  label="Highlighters"
                  type="checkbox" />
              </label>
              <label className="row">
                <Form.Input
                  name="decipher.other"
                  label="Other"
                  type="checkbox" />
              </label>
            </div></div>
        </Form.FieldGroup>

        <Form.FieldGroup label="Programming start date*" className="right to-right">
          <Form.Datepicker
            name="startDate" />
          <Form.FieldError name="startDate" />
        </Form.FieldGroup>

        <Form.FieldGroup label="QA start date" className="right to-right">
          <Form.Datepicker
            name="decipher.qaStartDate" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Launch date*" className="right to-right">
          <Form.Datepicker
            name="launchDate" />
          <Form.FieldError name="launchDate" />
        </Form.FieldGroup>

      </Fragment>
    );
  }
}

export default DecipherDetails;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectForm/DecipherDetails.js